import { render, staticRenderFns } from "./OrderInfoSummary.vue?vue&type=template&id=4053ea20&scoped=true"
import script from "./OrderInfoSummary.vue?vue&type=script&lang=js"
export * from "./OrderInfoSummary.vue?vue&type=script&lang=js"
import style0 from "./OrderInfoSummary.vue?vue&type=style&index=0&id=4053ea20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4053ea20",
  null
  
)

export default component.exports